import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tokens.css';
import { App, queryClient } from './app/App.tsx';
import { registerServiceWorker } from './sw/offline.tsx';

registerServiceWorker(queryClient); // STORE02 app shell + offline launch (production builds only)
createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
